<div>
    <div class="most-ordered-header">
        <a [routerLink]="['/menu']"><img src="../../../assets/back.svg" alt=""></a>
        <h2>{{ 'mostOrdered.topProducts' | translate }}</h2>
    </div>
    <div class="most-ordered-container">
        <div class="most-ordered-items">
            <app-most-ordered-item *ngFor="let product of featuredProducts" [mainView]="false" [comesFrom]="comesFrom" [product]="product" [currencySymbol]="currencySymbol"></app-most-ordered-item>
        </div>
    </div>
</div>